
import { Component, Prop, Vue } from 'vue-property-decorator'
import ItemTitle from '@/components/item-title/index.vue'
@Component({ components: { ItemTitle } })
export default class extends Vue {
  @Prop() private menuTitle!: string
  private linkArray = [
    {
      title: require('@/assets/images/exam/01.png'),
      url: 'https://www.acftu.org/'
    },
    {
      title: require('@/assets/images/exam/05.png'),
      url: 'https://www.china-wdf.org.cn/'
    },
    {
      title: require('@/assets/images/exam/06.png'),
      url: 'http://www.wp-china.com/f'
    },
    {
      title: require('@/assets/images/exam/04.png'),
      url: 'https://www.miit.gov.cn/'
    },
    {
      title: require('@/assets/images/exam/02.png'),
      url: 'http://www.mohrss.gov.cn/'
    },
    {
      title: require('@/assets/images/exam/03.png'),
      url: 'http://www.most.gov.cn/'
    }
    // {
    //   title: require('@/assets/images/exam/07.png'),
    //   url: 'http://www.cscec7b.com/'
    // }
  ]

  link (item: any) {
    const url = item.url
    window.open(url, '_blank')
  }
}
